<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item>
						<template>
							<el-form-item label="分类名称:" class='tiny' cleartable>
								<el-input style="width: 200px;" v-model="searchInfo.className" placeholder="请输入分类名称"></el-input>
							</el-form-item>
							<el-button type="primary" @click="search">搜索</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="editialogVisible('',1)">新增分类
							</el-button>
			
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="goodsClassList" style="width: 100%" row-key="id" :header-cell-style="headClass" lazy
			v-loading="loading" element-loading-text="拼命加载中">
		
			<el-table-column prop="orderIndex" label="排序级别" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="className" label="分类名" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="isShow" label="是否显示" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isShow">是</p>
					<p v-else>否</p>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
		
			<el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="bianji(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="del(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		
		<el-dialog style="float:rigin" title="品牌分类" :visible.sync="editDialogVisible" width="50%"
			:closeOnClickModal="false">
			<div class="app-container">
				<el-form ref="form" :model="form"  size="medium">
					<el-form-item label="分类名称:">
						<el-input type="text" style="width: 260px;"  size="small"
							v-model="form.classShowname" placeholder="请输入分类名称" />
					</el-form-item>
				
					
		
					<el-form-item label="排序级别:">
						<el-input type="text" style="width: 260px;" oninput="value=value.replace(/[^0-9.]/g,'')" size="small"
							v-model="form.orderIndex" placeholder="请输入数字" />
					</el-form-item>
					<el-form-item label="是否显示:" class="redItem">
						<el-switch v-model="form.isShow" :active-value="true" :inactive-value="false">
						</el-switch>
					</el-form-item>
					
					<el-form-item>
						<el-button :loading="loading" type="primary" @click="toEdit()">提交</el-button>
						<el-button @click="editDialogVisible = false">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		
		<el-dialog style="float:rigin" title="编辑分类" :visible.sync="bianjiDialog" width="50%" :close-on-click-modal="false"
			:show-close="false">
			<div class="app-container">
				<el-form ref="form" :model="form2"  size="medium">
					
					<el-form-item label="分类名称:">
						<el-input type="text" style="width: 260px;"  size="small"
							v-model="form2.className" placeholder="请输入分类名称" />
					</el-form-item>
				
					<el-form-item label="排序级别:">
						<el-input type="text" style="width: 260px;" oninput="value=value.replace(/[^0-9.]/g,'')" size="small"
							v-model="form2.orderIndex" placeholder="请输入数字" />
					</el-form-item>
					<el-form-item label="是否显示:" class="redItem">
						<el-switch v-model="form2.isShow" :active-value="true" :inactive-value="false">
						</el-switch>
					</el-form-item>
					<el-form-item>
						<el-button :loading="toEdit2Loading" type="primary" @click="toEdit2">提交</el-button>
						<el-button @click="quxiao">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('pp');
	
	export default{
		data(){
			return{
				searchInfo:{},
				loading:false,
				page: {
					pageNum: 1,
					pageSize: 10
				},
				goodsClassList:[],
				editDialogVisible:false,
				bianjiDialog:false,
				form: {
					id: 0,
					className: "",
					classShowname:'',
					level: "",
					isShow: "",
					image: "",
					orderIndex: 50,
					pid: 0
				},
				form2: {
					id: 0,
					className: "",
					classShowname:'',
					level: "",
					isShow: "",
					image: "",
					orderIndex: 50,
					pid: 0
				},
				classId:'',
				// formLabelWidth: "200px",
				httpUrl: urls,
				goodsImages: {},
				fileList: [],
				contentValue: "",
				showContentDialog: false,
				classGoods1List: [],
				// tableDataList:[ ]
				classGoods1Id:'',
				uploaded:0,
				bjId:'',
			}
		},
		methods:{
			//搜索
			search(){
				this.getClassList()
			},
			//清空
			empty(){
				this.searchInfo = {}
			},
			editialogVisible(){
				this.editDialogVisible = true
			},
			getClassList(){
				this.loading = true
				let data = {
					className:this.searchInfo.className,
					pageNum:1,
					pageSize: 10
				}
				this.$api.findChainGoodsClass(data).then(res=>{
			
					if(res.state == 'success'){
						this.goodsClassList = res.data.list
						this.loading = false
					}
				})
			},
			// 添加
			toEdit(){
			
			
				let data = {
			
					className:this.form.classShowname,
				
					isShow:this.form.isShow,
					orderIndex:this.form.orderIndex
				}
				this.$api.addGoodschainClass(data).then(res=>{
				
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getClassList()
					}
				})
			},
			classGoods1(e){
				
				this.classGoods1Id = e
			},
			
			// 删除
			del(id){
				this.$confirm('是否删除该分类?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					this.$api.delGoodschainClass(id).then(res => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getClassList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//编辑
			bianji(id){
				this.bjId = id
				this.bianjiDialog = true
				this.$api.findByIdchainClass(id).then(res=>{
					
					if(res.state == 'success'){
						this.form2 = res.data
						
					
					}
				})
			},
			quxiao(){
				this.bianjiDialog = false
				this.fileList = []
			},
			//编辑提交
			toEdit2(id){
				this.toEdit2Loading = true;
				let data = {
					id:this.bjId,
					className:this.form2.className,
				
					isShow:this.form2.isShow,
					orderIndex:this.form2.orderIndex
				}
				this.$api.addGoodschainClass(data).then(res=>{
				
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.bianjiDialog = false
						this.getClassList()
					}else {
						this.$message.error(res.message);
					}
					this.toEdit2Loading = false;
				})
			},
			beforeUpload(file){
				const img = new Image();
				const _this = this;
				const reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = function(e) {
				  img.src = e.target.result;
				  img.onload = function() {
					const width = img.width;
					const height = img.height;
					const isSizeValid = width == 64 && height == 64;
					if (!isSizeValid) {
					  _this.$message.error('上传图片的尺寸必须为 64x64 像素');
					  return false;
					}else{
						 return true;
					}
					
				  };
				};
				// return false
			},
			onSuccess(response, file, fileList) {
			
				this.goodsImages=response;
			
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
		},
		created() {
			this.getClassList()
			this.$api.goodsClassfindByPid(0).then((res) => { //商品一级分类
				if (res.state == 'success') {
					this.classGoods1List = res.data;
				}
			})
		}
	}
</script>

<style scoped lang="less">
	
	  /deep/.el-upload--picture-card{
		  width: 64px;
		  height: 64px;
		  line-height: 70px;
		  text-align: center;
	  }
</style>